import Popper from 'popper.js'
import ko from 'knockout'
export default {
  initialize: function (params) {
    this.visible = ko.observable(0)
    this.position = params.position || 'top'
    this.myPopper = ''
    let reg = /(top)|(right)|(bottom)|(left)/g
    this.thisClass = 'y-poptip-' + this.position.match(reg)
    if (this.position.indexOf('-') > -1) {
      this.thisClass += ' y-poptip-' + this.position
    }
  },
  subscribe: function (params) {
    this.visible.subscribe(val => {
      if (!this.myPopper && val) {
        let reference = this.$el.querySelector('.element')
        let popper = this.$el.querySelector('.y-poptip-ctn')
        this.myPopper = new Popper(
          reference,
          popper,
          {
            placement: this.position,
            onCreate: (data) => {},
            onUpdate: (data) => {},
            positionFixed: true,
            modifiers: {
              preventOverflow: {
                enabled: false
              }
            }
          }
        )
      } else {
        this.myPopper && this.myPopper.update()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/poptip/common.js